import { SET_INSTAGRAM } from "./types"

const initialState = {
  instagram: {
    isActive: false,
    user: null,
    openedInCampaignPage: [],
    openedInAmbassadorPageUserId: [],
    modalShouldCheckReelsReactivatedAt: null,
  },
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_INSTAGRAM:
      return {
        ...state,
        instagram: { ...state.instagram, ...action.payload },
      }
    default:
      return state
  }
}
export default reducer
